import { Paper, TextField, Button } from "@material-ui/core";
import { MdFileDownload } from "react-icons/md";
import styled from "styled-components";

export const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 28px;
`;

export const ReportsHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 25%;
`;

export const Title = styled.h1``;

export const ExportReportsButton = styled(Button).attrs({
  size: "small",
  color: "primary",
  variant: "contained",
})`
  padding: 12px;
`;

export const SelectDateContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StartAt = styled(TextField).attrs({ variant: "outlined" })``;

export const EndAt = styled(TextField).attrs({
  variant: "outlined",
})`
  margin-left: 22px;
  margin-right: 22px;
`;
export const UpdateButton = styled(Button).attrs({
  size: "large",
  color: "primary",
  variant: "contained",
})``;

export const AllReportsContainer = styled.div`
  width: 97%;
  height: 440px;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 28px;
  margin-top: 32px;
`;

export const AllReportsTitle = styled.h2``;

export const ReportContent = styled.div`
  width: 40%;
  height: 100px;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  margin-top: 22px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
`;

export const ReportTitle = styled.strong``;

export const ReportDescription = styled.p``;

export const ExportButton = styled(Button).attrs({
  size: "small",
  color: "primary",
  variant: "contained",
})`
  padding: 10px;
`;

export const DownloadIcon = styled(MdFileDownload)`
  font-size: 18px;
  margin-left: 8px;
`;
